import React from 'react';
import ActivityStatusBar from '../../../components/activity-status-bar/activity-status-bar';
import TableHeader from '../../../components/table-header/table-header';
import css from './single-class.scss';
import { getTranslationKey } from '../../../helpers/locale-helpers';
import { NUM_ACTIVITIES } from '../../../components/report-filters/filter-constants';

const GROUP_NAME = 'name';
const COURSE_NAME = 'courseName';
const TOTAL_ACTIVITIES = 'totalActivities';
const STUDENT_NAME = 'fullName';
const ACTIVITY_RESULTS = 'activityResults';

const SINGLE_CLASS_TABLE_CONFIG = {
    cols: [
        {
            id: GROUP_NAME,
            name: '', // this is set to teacher name in the SingleClass component
            truncate: true,
            headerTruncate: true,
            onClick: null, // this is set to load group view for class view only in SingleClass component
            classes: css['group-name'],
            sort: null // this is set to sort for class view only in SingleClass component
        },
        {
            id: COURSE_NAME,
            name: 'Course',
            truncate: true,
            classes: css['course-name'],
            headerTransform: () => null // this is set in the SingleClass component
        },
        {
            id: TOTAL_ACTIVITIES,
            name: '' // this is set to class total in the SingleClass component
        }
    ],
    colGroups: [
        [
            {
                name: 'Activity Mastery',
                headerTransform: () => (
                    <TableHeader
                        title={'Table Header - Activity Mastery'}
                        translate
                    />
                ),
                colIds: [GROUP_NAME, COURSE_NAME]
            },
            {
                name: getTranslationKey(NUM_ACTIVITIES),
                doTranslation: true,
                colIds: [TOTAL_ACTIVITIES],
                classes: `text-center ${css['total-activities']}`
            }
        ]
    ],
    nestedData: {
        id: 'students',
        cols: [
            {
                id: STUDENT_NAME,
                truncate: true,
                classes: css['student-name'],
                onClick: () => null // this is set in the SingleClass component
            },
            {
                id: ACTIVITY_RESULTS,
                classes: css['activity-results'],
                transform: (row) => {
                    const activityMastery = {
                        scoreBand: row.scoreBand,
                        goldBars: row.goldBars,
                        totalActivities: row.totalActivities
                    };
                    return (
                        <ActivityStatusBar activityMastery={activityMastery} />
                    );
                }
            }
        ]
    }
};

export {
    SINGLE_CLASS_TABLE_CONFIG,
    GROUP_NAME,
    COURSE_NAME,
    TOTAL_ACTIVITIES,
    STUDENT_NAME
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/single-class/single-class-constants.js